import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { shouldUpdate } from 'recompose';
import NavBarContainer from '../../../containers/PageStructure/NavBar/NavBarContainer';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('header');
const { basename } = globals.urls;
const styles = {
  menuItem: { cursor: 'pointer' },
  list: { paddingTop: '3px', paddingBottom: '3px' },
  anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
  targetOrigin: { horizontal: 'left', vertical: 'top' },
};

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = event => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleLogout = () => {
    this.props.logoutAndRedirect();
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { name } = this.props;
    const imageSource = `${basename}images/branding/Allocate-Solutions-ECommunity.png`;
    const altText = locale.getMsg('applicationLogo');
    const logOutText = locale.getMsg('logout');
    return (
      <header className="page-header">
        <div className="header">
          <div className="logo-area">
            <img alt={altText} src={imageSource} />
          </div>
          {name && (
            <div className="action-area">
              <button className="icon-extend icon-person" onClick={this.handleClick}>
                {name}
              </button>
              <Popover
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                anchorOrigin={styles.anchorOrigin}
                targetOrigin={styles.targetOrigin}
                onRequestClose={this.handleRequestClose}
              >
                <Menu desktop listStyle={styles.list}>
                  {this.props.isAuthenticated ? (
                    <MenuItem>
                      <a
                        id="logout-header-navlink"
                        tabIndex="0"
                        role="link"
                        style={styles.menuItem}
                        onClick={this.handleLogout}
                      >
                        {logOutText}
                      </a>
                    </MenuItem>
                  ) : (
                    <MenuItem id="signin-header-navlink" to="/SignIn">
                      Login
                    </MenuItem>
                  )}
                </Menu>
              </Popover>
            </div>
          )}
        </div>
        <NavBarContainer {...this.props} />
      </header>
    );
  }
}

Header.defaultProps = {
  name: null,
};

Header.propTypes = {
  name: PropTypes.string,
  logoutAndRedirect: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const checkPropsChange = (props, nextProps) =>
  props.name !== nextProps.name || props.isAuthenticated !== nextProps.isAuthenticated;

export default shouldUpdate(checkPropsChange)(Header);
